import { useMemo } from "react";

export interface UserInfo {
  name: string;
  email: string;
  avatar?: string;
  initials?: string;
  bgColor?: string;
}

/**
 * Read user_info cookie set by the auth BE.
 * Non-HttpOnly cookie available across *.gaz.codes subdomains.
 */
function readUserInfoCookie(): UserInfo | null {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(/(?:^|;\s*)user_info=([^;]*)/);
  if (!match?.[1]) return null;
  try {
    const parsed = JSON.parse(decodeURIComponent(match[1]));
    return {
      name: parsed.name ?? "",
      email: parsed.email ?? "",
      avatar: parsed.avatar ?? undefined,
      initials: parsed.initials ?? undefined,
      bgColor: parsed.bgColor ?? undefined,
    };
  } catch {
    return null;
  }
}

/**
 * Hook to read the auth user_info cookie once on mount.
 * Returns user display info (name, email, avatar, initials, bgColor) or null.
 */
export function useUserInfo(): UserInfo | null {
  return useMemo(() => readUserInfoCookie(), []);
}
